module.exports = __webpack_public_path__ + "img/info-white.753dad03.svg";